<p-dialog
  [styleClass]="'acv_dialog'"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [style]="{'width': '31%'}"
  [modal]="true"
  [visible]="show_Dialog"
  [appendTo]="appendTo">

  <ng-template pTemplate="header">
    <div class="flex wd-100 dialog_header_wrapper align-items-center justify-content-between ng-star-inserted">
      <span class="text-xl font-bold">{{title}}</span>
      <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-rounded p-button-danger p-button-text p-button-raised"></p-button>
    </div>
  </ng-template>

  <div class="dialog_content_wrapper">
    <form [formGroup]="rejectForm" *ngIf="rejectForm">
      <div class="grid m-0">
        <div class="col-12">
          <acv-text-input
            [form]="rejectForm"
            ControlName="reason"
            [ControlType]="'text-area'"
            [ControlLabelText]="'Rejection Reason'"
            [PlaceHolderText]="'Please provide a reason for rejecting this lead...'"
            [characterLimit]="250"
            [IsSubmited]="is_form_submit"
            [ShowWordCount]="true"
            [Required]="true">
          </acv-text-input>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      (onClick)="handleCancelConfirm()"
      type="button"
      label="Cancel"
      class="p-button-text elevated-btn secondary mr-2">
    </p-button>
    <p-button
      type="button"
      label="Reject Lead"
      (onClick)="handleSubmitForm()"
      [loading]="isLoading"
      [disabled]="!rejectForm.valid"
      class="p-button-text elevated-btn primary mr-2">
    </p-button>
  </ng-template>
</p-dialog>
